{
  "v11.lecteur.annulation.confirmer": "Confirmer l’annulation",
  "v11.lecteur.annulation.echec": "L’annulation n’a pas abouti.",
  "v11.lecteur.annulation.faite": "Sollicitation annulée.",
  "v11.lecteur.annulation.propriete": "Le serveur vérifie que la sollicitation est bien la vôtre.",
  "v11.lecteur.annulation.sans_droits": "L’annulation retire la sollicitation sans modifier vos droits.",
  "v11.lecteur.annuler": "Annuler",
  "v11.lecteur.annuler_sollicitation.titre": "Annuler une sollicitation personnelle",
  "v11.lecteur.cible.apercu": "Aperçu {{application}} · révision {{revision}} · {{etat}}",
  "v11.lecteur.cible.aucune_choisie": "Aucune cible choisie.",
  "v11.lecteur.cible.deploiement": "Déploiement en {{environnement}} · commit {{revision}} · {{etat}}",
  "v11.lecteur.cible.libelle": "Cible d’application",
  "v11.lecteur.cible_application.titre": "Application de la version sélectionnée",
  "v11.lecteur.cibles.choisir": "Choisissez une cible parmi les {{n}} disponibles.",
  "v11.lecteur.cibles.quoi": "des cibles disponibles",
  "v11.lecteur.cibles.titre": "Cibles disponibles",
  "v11.lecteur.cibles.vide": "Aucune cible pour cette version : ni aperçu à sa révision, ni déploiement.",
  "v11.lecteur.circuit.aucun": "Aucun destinataire n’est désigné : l’administration de l’organisation décidera.",
  "v11.lecteur.circuit.chargement": "Recherche des personnes habilitées…",
  "v11.lecteur.circuit.non_divulguable": "Les personnes habilitées ne peuvent pas vous être nommées.",
  "v11.lecteur.circuit.profils": "Décidée par : {{profils}}.",
  "v11.lecteur.code.ACCESS_REQUEST_ALREADY_MEMBER": "Vous êtes déjà membre de ce projet.",
  "v11.lecteur.code.ACCESS_REQUEST_ALREADY_PENDING": "Une sollicitation est déjà en attente pour ce projet.",
  "v11.lecteur.code.ACCESS_REQUEST_NOT_FOUND": "Cette sollicitation est introuvable ou n’est pas la vôtre.",
  "v11.lecteur.code.ACCESS_REQUEST_NOT_PENDING": "Cette sollicitation a déjà reçu une réponse : elle ne peut plus être annulée.",
  "v11.lecteur.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour lire ces cibles.",
  "v11.lecteur.code.RESOURCE_UNAVAILABLE": "Cette version est introuvable dans ce projet.",
  "v11.lecteur.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v11.lecteur.code.VALIDATION_ERROR": "La saisie n’est pas valide.",
  "v11.lecteur.effets.admission": "La sollicitation porte sur l’admission seulement, avec le profil Lecteur.",
  "v11.lecteur.effets.aucun_droit": "Aucun droit n’est accordé par l’envoi : la décision revient à une personne habilitée.",
  "v11.lecteur.effets.suivi": "Vous la suivez dans vos demandes et pouvez l’annuler tant qu’elle est en attente.",
  "v11.lecteur.envoi_echec": "La sollicitation n’a pas pu être envoyée.",
  "v11.lecteur.envoyee": "Sollicitation envoyée.",
  "v11.lecteur.envoyer": "Envoyer la sollicitation",
  "v11.lecteur.espaces_illisibles": "La liste de vos projets n’a pas pu être lue.",
  "v11.lecteur.etat.chargement": "Chargement {{quoi}}…",
  "v11.lecteur.etat.en_cours": "En cours…",
  "v11.lecteur.etat.erreur": "La lecture {{quoi}} n’a pas abouti.",
  "v11.lecteur.etat.reessayer": "Réessayer",
  "v11.lecteur.etat.refus": "La lecture {{quoi}} vous est refusée.",
  "v11.lecteur.etat_apercu.disponible": "disponible",
  "v11.lecteur.etat_apercu.expiree": "expiré",
  "v11.lecteur.etat_apercu.indisponible": "indisponible",
  "v11.lecteur.etat_deploiement.disponible": "disponible",
  "v11.lecteur.etat_deploiement.indisponible": "indisponible",
  "v11.lecteur.etat_deploiement.revision_incompatible": "révision incompatible",
  "v11.lecteur.fermer": "Fermer",
  "v11.lecteur.liens.apercu_expire": "Cet aperçu a expiré : relancez-le depuis la fiche de la version.",
  "v11.lecteur.liens.apercu_indisponible": "Cet aperçu n’est pas en marche.",
  "v11.lecteur.liens.aucun_apercu": "Aucun aperçu choisi.",
  "v11.lecteur.liens.aucun_deploiement": "Aucun déploiement choisi.",
  "v11.lecteur.liens.choisir_d_abord": "Choisissez d’abord une cible.",
  "v11.lecteur.liens.comprendre_acces": "Comprendre mon accès",
  "v11.lecteur.liens.deploiement_indisponible": "Ce déploiement n’a pas abouti.",
  "v11.lecteur.liens.ouvrir_apercu": "Ouvrir l’aperçu",
  "v11.lecteur.liens.ouvrir_service": "Ouvrir le service",
  "v11.lecteur.liens.retour_version": "Revenir à la version",
  "v11.lecteur.liens.retour_vue": "Revenir au projet",
  "v11.lecteur.liens.revision_incompatible": "L’environnement sert depuis une autre version.",
  "v11.lecteur.motif.aide": "Dites pourquoi vous avez besoin de ce projet ; le motif est transmis aux personnes qui décident.",
  "v11.lecteur.motif.libelle": "Motif de la sollicitation",
  "v11.lecteur.motif.obligatoire": "Le motif est obligatoire.",
  "v11.lecteur.motif.trop_long": "Le motif dépasse {{max}} caractères.",
  "v11.lecteur.portee.admission": "Admission au projet {{projet}}, avec le profil Lecteur par défaut.",
  "v11.lecteur.sans_organisation": "Aucune organisation n’est associée à votre session.",
  "v11.lecteur.sans_projet": "Aucun projet n’est désigné.",
  "v11.lecteur.selection.application": "Application",
  "v11.lecteur.selection.chargement": "Chargement de la cible choisie…",
  "v11.lecteur.selection.commit": "Commit",
  "v11.lecteur.selection.correspondance_revision": "Correspondance exacte : révision {{revision}} de la version {{numero}}.",
  "v11.lecteur.selection.correspondance_terme": "Correspondance",
  "v11.lecteur.selection.correspondance_version": "Correspondance exacte : déploiement de la version {{numero}}.",
  "v11.lecteur.selection.depend_de_la_liste": "La cible choisie dépend de la liste des cibles.",
  "v11.lecteur.selection.environnement": "Environnement : {{nom}}",
  "v11.lecteur.selection.environnement_terme": "Environnement",
  "v11.lecteur.selection.revision": "Révision",
  "v11.lecteur.selection.titre": "Cible choisie",
  "v11.lecteur.selection.version": "Version",
  "v11.lecteur.sollicitation.deja_annulee": "Cette sollicitation est déjà annulée.",
  "v11.lecteur.sollicitation.depuis": "Envoyée le",
  "v11.lecteur.sollicitation.introuvable": "Aucune sollicitation à vous de ce numéro sur ce projet.",
  "v11.lecteur.sollicitation.motif": "Motif",
  "v11.lecteur.sollicitation.projet": "Projet",
  "v11.lecteur.sollicitation.quoi": "de la sollicitation",
  "v11.lecteur.sollicitation.sans_motif": "Sans motif",
  "v11.lecteur.sollicitation.statut": "Statut",
  "v11.lecteur.solliciter.titre": "Solliciter un accès au projet",
  "v11.lecteur.statut.approved": "Acceptée",
  "v11.lecteur.statut.cancelled": "Annulée",
  "v11.lecteur.statut.pending": "En attente",
  "v11.lecteur.statut.rejected": "Refusée",
  "v11.lecteur.suivi.quoi": "de vos sollicitations",
  "v11.lecteur.version.designation_absente": "Aucune version désignée par le responsable des mises en production : la plus récente est affichée.",
  "v11.lecteur.version.identifiee": "Version {{numero}} (commit {{commit}})",
  "v11.lecteur.version.la_plus_recente": "La plus récente",
  "v11.lecteur.version.libelle": "Version à recetter",
  "v11.lecteur.version.liste_illisible": "La liste des versions n’a pas pu être lue : seule la plus récente est proposée.",
  "v11.lecteur.version.titre": "Version et cibles"
}
